import React from 'react';
import { HomeIcon, ClockIcon, RefreshCwIcon, UserIcon } from 'lucide-react';
interface MobileLayoutProps {
  children: React.ReactNode;
  activeTab: 'home' | 'history' | 'sync' | 'profile';
  onTabChange: (tab: 'home' | 'history' | 'sync' | 'profile') => void;
  isOnline?: boolean;
}
export function MobileLayout({
  children,
  activeTab,
  onTabChange,
  isOnline = true
}: MobileLayoutProps) {
  return <div className="flex flex-col h-full w-full bg-gray-50 relative overflow-hidden" data-id="element-279">
      {/* Header */}
      <header className="flex items-center justify-between px-4 py-3 text-white shadow-md z-10 shrink-0" style={{
      backgroundColor: '#134073'
    }} data-id="element-280">
        <div className="flex items-center gap-3" data-id="element-281">
          <div className="bg-white p-1 rounded-md h-8 w-8 flex items-center justify-center" data-id="element-282">
            <img src="https://cdn.magicpatterns.com/uploads/wszHE4itFVKfiMMSe74Psk/logohospigen.png" alt="Logo HSJD" className="h-full object-contain" data-id="element-283" />
          </div>
          <h1 className="font-bold text-lg tracking-tight" data-id="element-284">Lavandería HSJD</h1>
        </div>
        <div className="flex items-center" data-id="element-285">
          <div className={`w-3 h-3 rounded-full ${isOnline ? 'bg-green-400' : 'bg-red-400'} border-2 border-white`} title={isOnline ? 'En línea' : 'Sin conexión'} data-id="element-286" />
        </div>
      </header>

      {/* Main Content Area */}
      <main className="flex-1 overflow-y-auto pb-20" data-id="element-287">{children}</main>

      {/* Bottom Navigation */}
      <nav className="absolute bottom-0 left-0 right-0 bg-white border-t border-gray-200 flex justify-around items-center h-16 px-2 pb-safe z-20 shadow-[0_-2px_10px_rgba(0,0,0,0.05)]" data-id="element-288">
        <button onClick={() => onTabChange('home')} className={`flex flex-col items-center justify-center w-full h-full space-y-1 ${activeTab === 'home' ? 'text-blue-600' : 'text-gray-500'}`} style={activeTab === 'home' ? {
        color: '#3d99d2'
      } : {}} data-id="element-289">
          <HomeIcon className="w-6 h-6" data-id="element-290" />
          <span className="text-[10px] font-medium" data-id="element-291">Inicio</span>
        </button>

        <button onClick={() => onTabChange('history')} className={`flex flex-col items-center justify-center w-full h-full space-y-1 ${activeTab === 'history' ? 'text-blue-600' : 'text-gray-500'}`} style={activeTab === 'history' ? {
        color: '#3d99d2'
      } : {}} data-id="element-292">
          <ClockIcon className="w-6 h-6" data-id="element-293" />
          <span className="text-[10px] font-medium" data-id="element-294">Historial</span>
        </button>

        <button onClick={() => onTabChange('sync')} className={`flex flex-col items-center justify-center w-full h-full space-y-1 relative ${activeTab === 'sync' ? 'text-blue-600' : 'text-gray-500'}`} style={activeTab === 'sync' ? {
        color: '#3d99d2'
      } : {}} data-id="element-295">
          <div className="relative" data-id="element-296">
            <RefreshCwIcon className="w-6 h-6" data-id="element-297" />
            <span className="absolute -top-1 -right-2 bg-red-500 text-white text-[8px] font-bold px-1.5 py-0.5 rounded-full border border-white" data-id="element-298">
              2
            </span>
          </div>
          <span className="text-[10px] font-medium" data-id="element-299">Sincronizar</span>
        </button>

        <button onClick={() => onTabChange('profile')} className={`flex flex-col items-center justify-center w-full h-full space-y-1 ${activeTab === 'profile' ? 'text-blue-600' : 'text-gray-500'}`} style={activeTab === 'profile' ? {
        color: '#3d99d2'
      } : {}} data-id="element-300">
          <UserIcon className="w-6 h-6" data-id="element-301" />
          <span className="text-[10px] font-medium" data-id="element-302">Perfil</span>
        </button>
      </nav>
    </div>;
}